module.exports = __webpack_public_path__ + "img/Bitmap.cb57b1f3.png";